module.exports = __webpack_public_path__ + "img/zak.bb382ac.webp";